import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import BlogCategoryTable from "./Components/BlogCategoryTable";

const BlogCategoryList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Blog Categories</HeadingOne>
                    <div className="d-flex gap-2 flex-wrap mt-sm-0 mt-2">
                        <AddItemBtn url="add-blog-category" title="Add Category" />
                    </div>
                </>
            }
        >
            <div className="col-12">
                <BlogCategoryTable />
            </div>
        </PageBody>
    );
};

export default BlogCategoryList;
